import React, { useState, useEffect } from "react";
import SellerEditProfile from "./SellerEditProfile";
import BusinessProfile from "./BusinessProfile";
import KYCInformation from "./KYCInformation";
import ManageSocialMedia from "./ManageSocialMedia";
import SocialLinks from "./SocialLinks";
import { useSelector } from "react-redux";
import { getUser } from "../../../../utils/commonfunction";
import { ROLE } from "../../../../utils/Constants";
import { profileDetails } from "../../services/user.service";

function ProfileSeller() {
  const [activeTab, setActiveTab] = useState("business-profile");
  const reduxUserData = useSelector((state) => state.profile.profileData);
  const [userData, setUserData] = useState(() => {
    let u = getUser(ROLE.USER);
    if (!u || Object.keys(u).length === 0) {
      u = getUser(ROLE.ADVERTISER) || {};
    }
    return u;
  });

  useEffect(() => {
    if (reduxUserData && Object.keys(reduxUserData).length > 0) {
      setUserData((prev) => ({ ...prev, ...reduxUserData }));
    }
  }, [reduxUserData]);

  useEffect(() => {
    profileDetails()
      .then((res) => {
        if (res && res.data) {
          setUserData((prev) => ({ ...prev, ...res.data }));
        }
      })
      .catch((err) => console.log("Failed fetching profile details in ProfileSeller:", err));
  }, []);

  const isVerifiedAdvertiser =
    (userData?.is_kyc_verified === true || userData?.is_kyc_verified === "true") &&
    (userData?.role === ROLE.ADVERTISER || userData?.isAdvertiser);

  const tabs = [
    // { key: "edit-profile", label: "Edit Profile" },
    { key: "business-profile", label: "Business Profile" },
    { key: "kyc-info", label: "KYC Information" },
    ...(isVerifiedAdvertiser
      ? [
          { key: "social-media", label: "Manage Social Media" },
          { key: "social-links", label: "Social Links" },
        ]
      : []),
  ];

  return (
    <div className="seller-profile-bg py-10">
      <div className="container">
        <div className="max-w-[797px] mx-auto">
          <h1 className="headings-h1 text-zinc-950 border-b border-gray-200 pb-[15px] mb-[30px]">
            Profile
          </h1>

          <div className="bg-white border border-zinc-100 p-[15px] md:p-[30px] lg:p-[40px] shadow-[0px_2px_24px_0px_rgba(0,0,0,0.05)] rounded-[10px]">
            {/* Tabs */}
            <div className="tabs tabs-boxed bg-transparent border-b border-gray-200 flex justify-between items-center gap-[15px] overflow-x-auto whitespace-nowrap flex-nowrap">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`tab tab-lg px-[15px] font-semibold rounded-none ${
                    activeTab === tab.key
                      ? "text-[#FF63B5] border-b-2 border-[#FF63B5]"
                      : "text-gray-500 border-b-2 border-transparent"
                  }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="tab-content-bg mt-6">
              {activeTab === "edit-profile" && (
                <div className="tab-pane active">
                  <SellerEditProfile />
                </div>
              )}

              {activeTab === "business-profile" && (
                <div className="tab-pane">
                  <BusinessProfile />
                </div>
              )}

              {activeTab === "kyc-info" && (
                <div className="tab-pane">
                  <KYCInformation />
                </div>
              )}

              {activeTab === "social-media" && isVerifiedAdvertiser && (
                <div className="tab-pane">
                  <ManageSocialMedia />
                </div>
              )}

              {activeTab === "social-links" && isVerifiedAdvertiser && (
                <div className="tab-pane">
                  <SocialLinks />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileSeller;
  